module.exports = __webpack_public_path__ + "static/media/long_pattern.fac95655.png";